<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    aria-hidden="true"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    >
      <path
        d="M8.667 3.418a2.333 2.333 0 1 0 4.666 0 2.333 2.333 0 0 0-4.666 0ZM13.331 3.418h7.61M1.108 3.418h7.554M4 11.001a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0ZM8.662 11.001h12.279M1.108 11.001h2.887M6.333 18.584a2.333 2.333 0 1 0 4.667 0 2.333 2.333 0 0 0-4.667 0ZM10.995 18.584h9.946M1.108 18.584h5.225"
      />
    </g>
  </svg>
</template>
